import React, {useEffect, useState} from "react";
import {Route, Routes, useNavigate} from "react-router-dom";
import OptionalMenu from "../../../components/optional-menu/optional-menu";
import {optionalMenuAlarms, optionalMenuDevice} from "../optional-menu-items";
import {connect, useDispatch} from "react-redux";
import {getAlarm} from "../../../services/alarms.service";
import {AlarmCard} from "./alarm-card";
import Loader from "react-loader-spinner";
import {setDataInStore} from "../../../utils/setDataInStore";
import {getAllNames} from "../../../services/names.service";
import _ from "lodash";



interface AlarmsViewChildProps {
    alarmId: string;
    alarmNames: object
}

const AlarmsViewChild: React.FC<AlarmsViewChildProps> = (props) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    useEffect(() => {
        setLoading(true);
        getAlarm(props.alarmId)
            .then((data) => {
                setData(data);
                setDataInStore(dispatch, data, 'alarms.' + props.alarmId);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error: ", err);
                setLoading(false);
            });
    }, [props.alarmId]);
    const getName = () => {
        if (props.alarmId.includes('temp')) {
            return _.get(props.alarmNames, 'temperature.' + props.alarmId, '');
        } else if (props.alarmId.includes('humidity')) {
            return _.get(props.alarmNames, 'humidity.' + props.alarmId, '');
        } else if (props.alarmId.includes('input')) {
            return _.get(props.alarmNames, 'inputs.' + props.alarmId, '');
        }
        return _.get(props.alarmNames, 'analogs.' + props.alarmId, '')
    }
    if (!loading) {
        return (
            <div className='d-flex justify-content-center w-100 align-items-start mt-1'>
                {
                    props.alarmId && <AlarmCard id={props.alarmId} alarm={data} alarmName={getName()}/>
                }
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}
const AlarmsView: React.FC = () => {

    const navigate = useNavigate();
    const [key, setKey] = useState('');
    const [loading, setLoading] = useState(true);
    const [names, setNames] = useState({});
    const handleChangeDeviceKey = (key: string) => {
        setKey(key);
        navigate(key);
    }
    useEffect(() => {
        getAllNames().then(
            (res) => {
                setNames(res);
                console.log("RES: ", res);
                optionalMenuAlarms.value.temperature.items.map((item) => {
                    _.assign(item, {
                        label: _.get(res, 'temperature.' + item.key, item.key)
                    })
                    return item;
                });
                optionalMenuAlarms.value.humidity.items.map((item) => {
                    _.assign(item, {
                        label: _.get(res, 'humidity.' + item.key, item.key)
                    })
                    return item;
                });
                optionalMenuAlarms.value.inputs.items.map((item) => {
                    _.assign(item, {
                        label: _.get(res, 'inputs.' + item.key, item.key)
                    })
                    return item;
                });
                optionalMenuAlarms.value.analogInputs.items.map((item) => {
                    _.assign(item, {
                        label: _.get(res, 'analogs.' + item.key, item.key)
                    })
                    return item;
                });
                setLoading(false);
            }
        )
            .catch((err) => setLoading(false))
    }, [])
    if (!loading) {
        return (
            <div className='d-flex w-100'>
                <OptionalMenu {...optionalMenuAlarms} onChange={handleChangeDeviceKey}/>
                <Routes>
                    <Route path=":id" element={<AlarmsViewChild alarmId={key} alarmNames={names}/>}/>
                </Routes>
            </div>
        )
    }
    return <div className='w-100 d-flex justify-content-center pt-5'>
        <Loader
            type="Puff"
            color="#555374"
            height={100}
            width={100}
            timeout={3000} //3 secs

        />
    </div>;
}

export default connect(null)(AlarmsView);